const splitInfos = (value) => {
  if (!value) return '';

  const [number, court] = value.split(' - ');

  return { number, court };
};

export { splitInfos };
